(function () {
  'use strict';

  if (window.__vibeePredictiveInit) return;
  window.__vibeePredictiveInit = true;

  var SECTION_ID = 'vibee-predictive-search';
  var SECTION_DOM_ID = 'shopify-section-' + SECTION_ID;
  var MIN_CHARS = 2;
  var DEBOUNCE_MS = 220;
  var LIMIT = 8;

  var panel = null;
  var activeInput = null;
  var controller = null;
  var debounceTimer = null;
  var activeIndex = -1;
  var lastTerm = '';

  function buildPanel() {
    if (panel) return panel;
    panel = document.createElement('div');
    panel.className = 'vibee-psearch';
    panel.id = 'VibeePredictiveSearch';
    panel.setAttribute('role', 'listbox');
    panel.hidden = true;
    document.body.appendChild(panel);
    return panel;
  }

  function isOpen() {
    return panel && !panel.hidden;
  }

  function positionPanel() {
    if (!isOpen() || !activeInput) return;
    var rect = activeInput.getBoundingClientRect();
    var width = rect.width;
    var left = rect.left;
    var top = rect.bottom;
    panel.style.left = left + 'px';
    panel.style.top = top + 'px';
    panel.style.width = width + 'px';
  }

  function openPanel() {
    if (!panel) return;
    panel.hidden = false;
    if (activeInput) {
      activeInput.setAttribute('aria-expanded', 'true');
    }
    positionPanel();
  }

  function closePanel() {
    if (!panel || panel.hidden) return;
    panel.hidden = true;
    activeIndex = -1;
    if (activeInput) {
      activeInput.setAttribute('aria-expanded', 'false');
      activeInput.removeAttribute('aria-activedescendant');
    }
  }

  function getOptions() {
    if (!panel) return [];
    return Array.prototype.slice.call(panel.querySelectorAll('.vibee-psearch__link'));
  }

  function clearActive() {
    getOptions().forEach(function (el) {
      el.classList.remove('is-active');
      el.removeAttribute('aria-selected');
    });
  }

  function setActive(index) {
    var options = getOptions();
    if (!options.length) return;
    clearActive();
    if (index < 0) index = options.length - 1;
    if (index >= options.length) index = 0;
    activeIndex = index;
    var el = options[activeIndex];
    el.classList.add('is-active');
    el.setAttribute('aria-selected', 'true');
    if (!el.id) {
      el.id = 'vibee-psearch-opt-' + activeIndex;
    }
    if (activeInput) {
      activeInput.setAttribute('aria-activedescendant', el.id);
    }
    if (el.scrollIntoView) {
      el.scrollIntoView({ block: 'nearest' });
    }
  }

  function renderResults(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var section = doc.getElementById(SECTION_DOM_ID);
    panel.innerHTML = section ? section.innerHTML : html;
    activeIndex = -1;
    if (panel.querySelector('.vibee-psearch__list, .vibee-psearch__empty')) {
      openPanel();
    } else {
      closePanel();
    }
  }

  function fetchResults(term) {
    if (controller) controller.abort();
    controller = new AbortController();
    var url =
      '/search/suggest?q=' +
      encodeURIComponent(term) +
      '&section_id=' +
      SECTION_ID +
      '&resources[type]=product&resources[limit]=' +
      LIMIT +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,product_type,variants.title,vendor';

    fetch(url, { signal: controller.signal })
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        renderResults(html);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
      });
  }

  function ensureCombobox(input) {
    if (!input || input.tagName !== 'INPUT' || input.name !== 'q') return;
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-controls', 'VibeePredictiveSearch');
    if (!input.hasAttribute('aria-expanded')) {
      input.setAttribute('aria-expanded', 'false');
    }
  }

  function onInput(event) {
    var input = event.target;
    if (!input || input.name !== 'q') return;
    activeInput = input;
    ensureCombobox(input);
    var term = input.value.trim();
    lastTerm = term;
    if (debounceTimer) clearTimeout(debounceTimer);
    if (term.length < MIN_CHARS) {
      closePanel();
      return;
    }
    debounceTimer = setTimeout(function () {
      fetchResults(term);
    }, DEBOUNCE_MS);
  }

  function onFocusIn(event) {
    var input = event.target;
    if (!input || input.tagName !== 'INPUT' || input.name !== 'q') return;
    activeInput = input;
    ensureCombobox(input);
    input.setAttribute('aria-expanded', isOpen() ? 'true' : 'false');
    if (input.value.trim().length >= MIN_CHARS && lastTerm === input.value.trim() && panel && panel.children.length) {
      openPanel();
    }
  }

  function onKeydown(event) {
    if (!activeInput || event.target !== activeInput) return;
    var key = event.key;
    if (key === 'ArrowDown') {
      if (!isOpen()) return;
      event.preventDefault();
      setActive(activeIndex + 1);
    } else if (key === 'ArrowUp') {
      if (!isOpen()) return;
      event.preventDefault();
      setActive(activeIndex - 1);
    } else if (key === 'Enter') {
      var options = getOptions();
      if (isOpen() && activeIndex > -1 && options[activeIndex]) {
        event.preventDefault();
        window.location.href = options[activeIndex].getAttribute('href');
      }
    } else if (key === 'Escape') {
      if (isOpen()) {
        event.preventDefault();
        closePanel();
      }
    }
  }

  function onDocClick(event) {
    if (!isOpen()) return;
    if (panel.contains(event.target)) return;
    if (activeInput && activeInput.contains(event.target)) return;
    if (event.target.name === 'q') return;
    closePanel();
  }

  function init() {
    buildPanel();
    document.addEventListener('input', onInput, true);
    document.addEventListener('focusin', onFocusIn, true);
    document.addEventListener('keydown', onKeydown, true);
    document.addEventListener('click', onDocClick, true);
    window.addEventListener('scroll', positionPanel, true);
    window.addEventListener('resize', positionPanel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
